import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { faMoneyCheck } from '@fortawesome/free-solid-svg-icons';

import EntityTable from "../Listing/EntityTable";
import Accordion from "../NavTab/Accordion";
import SendInvoiceEmailModal from "../Modal/SendInvoiceEmailModal";

import useInvoiceColumns from "../../hooks/invoiceColumns";
import { formatAmount } from "../Order/invoiceColumns";
import PaymentMethodBadge from "../Order/PaymentMethodBadge";
import { formatRelativeDate } from "../../utils/FormatDate";
import { NavLink } from "react-router-dom";
import { API_BASE_URL } from '../../api';

const PatientInvoices = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [pdfData, setPdfData] = useState(null);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [emailTarget, setEmailTarget] = useState(null);

  const columns = useInvoiceColumns({
      setPdfData,
      setShowPdfModal,
      setPageNumber,
      setEmailTarget,
      excludeColumns: ["patientId"]
    });

  // Card-view design for this listing (Table's enableCardView feature, forced on mobile)
  // — reuses the actions column's own dropdown so both views offer identical actions.
  const invoicesActionsColumn = columns.find((c) => c.accessor === "actions");
  const renderInvoiceCard = (row) => (
    <div className="card h-100 shadow-sm">
      <div className="card-body d-flex flex-column" style={{ padding: 14, gap: 6 }}>
        <NavLink to={`/invoices/${row.id}`} style={{ fontSize: 13.5, fontWeight: 600, color: "#111827" }}>
          {row.invoiceNumber}
        </NavLink>
        <span style={{ fontSize: 11.5, color: "#9ca3af" }}>{formatRelativeDate(row.invoiceCreatedAt)}</span>

        {row.paymentMethod && (
          <div style={{ alignSelf: "flex-start" }}><PaymentMethodBadge method={row.paymentMethod} /></div>
        )}

        <div className="d-flex align-items-center justify-content-between" style={{ marginTop: "auto", paddingTop: 6 }}>
          <div style={{ display: "flex", alignItems: "baseline", gap: 4 }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>{formatAmount(row.totalAmount)}</span>
            <span style={{ fontSize: 10.5, color: "#9ca3af", fontWeight: 500 }}>dhs</span>
          </div>
          {invoicesActionsColumn?.Cell(row)}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Accordion
        id="patientInvoices"
        parent="patient_information_container"
        title={t('Invoices')}
        icon={faMoneyCheck}
        flush
      >
        <EntityTable
          endpoint={`${API_BASE_URL}/api/v1/invoices`}
          columns={columns}
          extraParams={{
            patientId: id
          }}
          defaultSort="id"
          defaultDirection="desc"
          pageSize={20}
          emptyMessage="Aucune facture"
          searchable={true}
          multiSelect={false}
          enableCardView={true}
          renderCard={renderInvoiceCard}
        />
      </Accordion>

      <SendInvoiceEmailModal invoice={emailTarget} onClose={() => setEmailTarget(null)} />
    </>
  );
};

export default PatientInvoices;